// src/components/NotificacoesButtons.js
import React, { useState, useEffect } from 'react';
import { FaBell, FaTimes, FaPaperPlane } from 'react-icons/fa';
import api from '../api/api';

const NotificacoesButtons = () => {
  const [showModal, setShowModal] = useState(false);
  const [novaNotificacao, setNovaNotificacao] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    // Conectar ao Socket.io
    const token = localStorage.getItem('token');
    if (token && window.io) {
      const newSocket = window.io(process.env.REACT_APP_API_URL || 'https://app.olympicbarbacena.com.br', {
        auth: {
          token: token
        }
      });

      newSocket.on('connect', () => {
        console.log('Conectado ao servidor de notificações');
      });
      newSocket.on('notification', (notification) => {
        console.log('Nova notificação:', notification);
        // Exibir notificação para o usuário
        
      });

      setSocket(newSocket);

      return () => newSocket.close();
    }
  }, []);

  const enviarNotificacao = async () => {
    if (!novaNotificacao.trim()) return;

    setEnviando(true);
    try {
      const response = await api.post('/notificacoes/broadcast', {
        mensagem: novaNotificacao,
        tipo: 'info'
      });

      if (response.data.success) {
        alert('Notificação enviada com sucesso!');
        setNovaNotificacao('');
        setShowModal(false);
        
        // Emitir via socket também
        if (socket) {
          socket.emit('notificacao:enviar', {
            mensagem: novaNotificacao,
            tipo: 'info',
            timestamp: new Date()
          });
        }
      }
    } catch (error) {
      console.error('Erro ao enviar notificação:', error);
      alert('Erro ao enviar notificação');
    } finally {
      setEnviando(false);
    }
  };

  const styles = {
    notificacaoContainer: {
      width: '100%',
      maxWidth: '900px',
      margin: '0 auto 20px auto',
      padding: '0 20px',
      display: 'flex',
      justifyContent: 'flex-end',
    },
    notificacaoButton: {
      backgroundColor: '#1A3B7D',
      background: 'linear-gradient(135deg, #1A3B7D 0%, #2D4B8C 100%)',
      color: 'white',
      border: 'none',
      borderRadius: '25px',
      padding: '12px 25px',
      fontFamily: 'Montserrat, sans-serif',
      fontSize: '16px',
      fontWeight: '600',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      boxShadow: '0 4px 8px rgba(26, 59, 125, 0.3)',
      transition: 'all 0.3s ease',
    },
    modalOverlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
    },
    modalContent: {
      backgroundColor: 'white',
      padding: '25px',
      borderRadius: '12px',
      width: '90%',
      maxWidth: '500px',
      boxShadow: '0 5px 20px rgba(0, 0, 0, 0.2)',
    },
    modalHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '20px',
    },
    modalTitle: {
      color: '#1A3B7D',
      fontFamily: 'Montserrat, sans-serif',
      fontSize: '18px',
      fontWeight: '600',
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
    },
    closeButton: {
      background: 'none',
      border: 'none',
      fontSize: '24px',
      cursor: 'pointer',
      color: '#666',
    },
    textArea: {
      width: '100%',
      padding: '15px',
      borderRadius: '8px',
      border: '1px solid #ddd',
      fontFamily: 'Montserrat, sans-serif',
      fontSize: '16px',
      marginBottom: '20px',
      resize: 'vertical',
      minHeight: '120px',
    },
    modalButtons: {
      display: 'flex',
      justifyContent: 'flex-end',
      gap: '10px',
    },
    cancelButton: {
      padding: '10px 20px',
      borderRadius: '8px',
      border: '1px solid #ccc',
      backgroundColor: 'white',
      color: '#333',
      fontFamily: 'Montserrat, sans-serif',
      fontWeight: '500',
      cursor: 'pointer',
    },
    sendButton: {
      padding: '10px 20px',
      borderRadius: '8px',
      border: 'none',
      backgroundColor: '#1A3B7D',
      color: 'white',
      fontFamily: 'Montserrat, sans-serif',
      fontWeight: '500',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
    },
  };

  return (
    <>
      <div style={styles.notificacaoContainer}>
        <button 
          style={styles.notificacaoButton}
          onClick={() => setShowModal(true)}
        >
          <FaBell />
          Enviar Notificação
        </button>
      </div>

      {showModal && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalContent}>
            <div style={styles.modalHeader}>
              <div style={styles.modalTitle}>
                <FaBell />
                Nova Notificação
              </div>
              <button 
                style={styles.closeButton}
                onClick={() => setShowModal(false)}
              >
                <FaTimes />
              </button>
            </div>
            
            <textarea
              style={styles.textArea}
              placeholder="Digite a mensagem da notificação..."
              value={novaNotificacao}
              onChange={(e) => setNovaNotificacao(e.target.value)}
            />
            
            <div style={styles.modalButtons}>
              <button 
                style={styles.cancelButton}
                onClick={() => setShowModal(false)}
              >
                Cancelar
              </button>
              <button 
                style={styles.sendButton}
                onClick={enviarNotificacao}
                disabled={enviando || !novaNotificacao.trim()}
              >
                <FaPaperPlane />
                {enviando ? 'Enviando...' : 'Enviar'}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default NotificacoesButtons;